// Lib
import { createAction } from '@reduxjs/toolkit';

export const SetAuthData = createAction('SET_AUTH_DATA');
export const ClearTokenData = createAction('CLEAR_TOKEN_DATA');
export const ClearSsoData = createAction('CLEAR_SSO_DATA');
